import { Component, OnInit } from '@angular/core';
import { PagosService, ReportesService, OptionsService } from '../../services/service.index';
import { Router } from '@angular/router';
import { AltaSolicitudesService } from '../../services/altasolicitudes/altasolicitudes.service';
import swal2 from 'sweetalert2';
// [13/08/2026] Se retiró Bugsnag: el dashboard no se revisaba hace ~1 año.

@Component({
  selector: 'app-decadena',
  templateUrl: './decadena.component.html',
  styles: []
})
export class DeCadenaComponent implements OnInit {

  cols: any[] = [];
  fecha: string;
  cadenas: any[] = [];
  cadenaso: any[] = [];
  cadenasw: any[] = [];
  cadenasow: any[] = [];
  correo: string = '';
  facturas: any[] = [];
  selectedFac: any[] = [];
  idp: string = '';
  idcontribuyente: string = '';
  idcontfinan: string = '';
  totalFac: number = 0;
  totalFacs: string = '0';
  totalFacsFormateado: string = '0';
  cdirecta: string = 'true';
  valorcdirecta: string = 'true';
  currency: any[] = [];
  paymentTypes: any[] = [];
  fill: boolean = true;
  nomname: string = '';
  bancos: any[] = [];
  showBanks: boolean = false;
  selectedBank: string = '';
  banks: any[] = [];
  hayBancos = false;
  npago = '';
  constructor(
    public router: Router,
    public _optionsservice: OptionsService,
    public _reportesservice: ReportesService,
    public _pagosservice: PagosService,
    private _solicitudesservice: AltaSolicitudesService
  ) {}

  ngOnInit() {
    swal2.showLoading();
    var a = new Date();
    a.setMinutes(a.getMinutes() + a.getTimezoneOffset());
    var montha = '' + (a.getMonth() + 1);
    var daya = '' + a.getDate();
    var yeara = a.getFullYear();
    if (montha.length < 2) { montha = '0' + montha; }
    if (daya.length < 2) { daya = '0' + daya; }
    this.fecha = [yeara, montha, daya].join('-');

    this.cols = [
      { field: 'folio_reporte', header: 'Folio Reporte' },
      { field: 'folio_factura', header: 'Folio Factura' },
      { field: 'uuid', header: 'UUID' },
      { field: 'monto_total', header: 'Monto Total' },
      { field: 'porcentaje_operado', header: 'Porcentaje Operado' },
      { field: 'emisor', header: 'Emisor' },
      { field: 'receptor', header: 'Receptor' },
      { field: 'moneda', header: 'Moneda' },
      { field: 'fecha_operacion', header: 'Fecha de operación' },
      { field: 'fecha_vencimiento', header: 'Fecha de vencimiento' },
      { field: 'fecha_emision', header: 'Fecha de emision' },
      { field: 'fecha_carga', header: 'Fecha de carga' },
      { field: 'estatus', header: 'Estatus' }
    ];

    this._pagosservice.getCadenas().subscribe(resp => {
      this.cadenas = resp;
      swal2.close();
    });

    this._solicitudesservice.getGeneralParam('NOMBRE_FINANCIERA').subscribe(resp => {
      this.nomname = resp['value'];
    });

    this._solicitudesservice.getPaymentCurrency().subscribe(resp => { this.currency = resp; });
    this._solicitudesservice.getPaymentTypes().subscribe(resp => { this.paymentTypes = resp; });

    this._pagosservice.getAcountigAcountBanks().subscribe(resp => {
      this.banks = resp;
      this.hayBancos = resp && resp.length > 0;
    });
  }

  seleccioncobranzadd() {
    this.valorcdirecta = (document.querySelector('input[name="screcurso"]:checked') as HTMLInputElement).value;
    this.cdirecta = this.valorcdirecta;
    this.cadenas = [];
    this.cadenasw = [];
    this.facturas = [];
    this.selectedFac = [];
    this.idp = '';
    this.npago = '';
    this.selectedBank = '';
    this.totalFacsFormateado = '0';
    (document.getElementById('correo') as HTMLInputElement).value = '';
    (document.getElementById('notas') as HTMLInputElement).value= '';
    (document.getElementById('voucher') as HTMLInputElement).value = '';
    swal2.showLoading();
    if (this.cdirecta === 'true') {
      this._pagosservice.getCadenas().subscribe(resp => {
        this.cadenas = resp;
        swal2.close();
      });
    } else {
      this._pagosservice.getCadenasw().subscribe(resp => {
        this.cadenasw = resp;
        swal2.close();
      });
    }
  }

  getcorreo() {
    this.facturas = [];
    this.selectedFac = [];
    this.totalFacsFormateado = '0';
    if (this.cdirecta === 'true') {
      var select: any = document.getElementById('cadena');
      var value = select.options[select.selectedIndex].value;
      for (var i in this.cadenas) {
        if (this.cadenas[i].id_cadena == value) {
          this.idp = this.cadenas[i].id_cadena;
          this.correo = this.cadenas[i].email_contribuyente;
          this.idcontribuyente = this.cadenas[i].id_contribuyente;
          this.idcontfinan = this.cadenas[i].id_cont_finan;
        }
      }
    } else {
      var selectw: any = document.getElementById('cadenaw');
      var valuew = selectw.options[selectw.selectedIndex].value;
      for (var j in this.cadenasw) {
        if (this.cadenasw[j].id_proveedor == valuew) {
          this.idp = this.cadenasw[j].id_proveedor;
          this.correo = this.cadenasw[j].email_contribuyente;
          this.idcontribuyente = this.cadenasw[j].id_contribuyente;
          this.idcontfinan = this.cadenasw[j].id_cont_finan;
        }
      }
    }
  }

  muestraFacturas() {
    var moneda: any = document.getElementById('moneda');
    var valormoneda = moneda.options[moneda.selectedIndex].value;

    if (this.showBanks && !this.selectedBank) {
      swal2.fire('Debe seleccionar un banco', '', 'error');
      return;
    }

    swal2.fire({ title: 'Cargando', allowOutsideClick: false });
    swal2.showLoading();

    if (this.idp === '' && this.cdirecta === 'true') {
      swal2.fire('Debe seleccionar una empresa', '', 'error');
      return;
    }
    if (this.idp === '' && this.cdirecta === 'false') {
      swal2.fire('Debe seleccionar un proveedor', '', 'error');
      return;
    }

    var call$ = this.cdirecta === 'true'
      ? this._pagosservice.getFacturasPagoCadena(this.idp, valormoneda)
      : this._pagosservice.getFacturasPagoCadenaw(this.idp, valormoneda);

    call$.subscribe(resp => {
      swal2.close();
      this.facturas = resp;
      this.fill = false;
      if (!resp || resp.length === 0) {
        swal2.fire('No se encontraron Datos', '', 'error');
      }
    }, function (err) {
      swal2.close();
      console.log(err);
      swal2.fire(
        'Ocurrió un error',
        (err.error && err.error.errors && err.error.errors[0]) ? err.error.errors[0] : '',
        'error'
      ).then(() => this.ngOnInit());
    }.bind(this));
  }

  getTotal() {
    var tp = 0;
    for (var i in this.selectedFac) {
      tp += parseFloat(this.selectedFac[i].monto_total.replace(/,/g, ''));
    }
    this.totalFacs = tp.toFixed(2);
    this.totalFacsFormateado = tp.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  filtro(e: any) {
    var moneda: any = document.getElementById('moneda');
    var valormoneda = moneda.options[moneda.selectedIndex].value;

    var call$ = null;
    if (e === 'NO DESCONTADA') {
      call$ = this._reportesservice.getPaymentsNoDescontada(valormoneda, this.idp);
    } else if (e === 'DESCONTADAS SIN FONDEO') {
      call$ = this._reportesservice.getPaymentsDescontadaSinFondeo(valormoneda, this.idp);
    } else if (e === 'DESCONTADAS CON FONDEO') {
      call$ = this._reportesservice.getPaymentsDescontadaConFondeo(valormoneda, this.idp);
    }

    if (call$) {
      call$.subscribe(r => { this.facturas = r; });
    }
  }

  guardar() {

    if (this.selectedFac.length === 0) {

      swal2.fire(
        'Debe seleccionar al menos una Factura',
        '',
        'error'
      );

    } else {

      const tpago: any = document.getElementById('tdpago');
      const moneda: any = document.getElementById('moneda');

      const valortpago = tpago.options[tpago.selectedIndex].value;
      const valormoneda = moneda.options[moneda.selectedIndex].value;
      let payment_number = (document.getElementById('npago') as HTMLInputElement).value;
      const payment: any = {
        payment_date: (document.getElementById('fecha') as HTMLInputElement).value,
        payment_number: payment_number,
        payment_type: valortpago,
        currency: valormoneda,
        amount: this.totalFacs,
        email_cfdi: (document.getElementById('correo') as HTMLInputElement).value,
        notes: (document.getElementById('notas') as HTMLInputElement).value,
        voucher: (document.getElementById('voucher') as HTMLInputElement).value,
        contributor_from_id: this.idcontribuyente,
        contributor_to_id: this.idcontfinan
      };
      if (this.hayBancos && this.selectedBank) {
        payment.bank = this.selectedBank; 
      }
      const params = {
        payment_source: 'CADENA',
        invoices: [],
        payment: payment
      }; 
      // tslint:disable-next-line: forin
      for (const prop in this.selectedFac) {
        params.invoices[prop] = {id: this.selectedFac[prop].id_factura.toString() };
      }
      swal2.fire({
        title: 'Cargando',
        allowOutsideClick: false
   });
      swal2.showLoading();
      this._pagosservice.aplicarPagoRAWproveedor(params).subscribe( resp => {
        // swal2.close();
        swal2.fire({
          title: 'La información se registró',
          text: 'con éxito',
          icon: 'success',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }). then ( res => {

          if ( res.value ) {
            this._pagosservice.notificacionPagoFacturas({id: resp['data'].id}).subscribe(() => {
              window.location.reload();

            }, err => {
              console.log(err);
              try{
                swal2.fire('Atención', err.error.error, 'info');
              }
              catch{
                swal2.fire('Atención', 'Algo salió mal al enviar notificación', 'info');
              }
            });
          }

        } );

      }, (err) => {
        swal2.close();
        console.log(err);
        swal2.fire({
          title: 'Ocurrio un error',
          text: err.error.errors[0],
          icon: 'error',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }). then ( res => {
          if ( res.value ) {
            this.ngOnInit();
          }
        } );
       } );

    }


  }

}








